import type { ShippingOption } from '@/modules/cart/domain/Cart';

const getShopsFromRegion = (
  shippingOptions: ShippingOption,
  communeCode: string,
  isCommunePresent: boolean
) => {
  return isCommunePresent
    ? {
        ...shippingOptions,
        options: shippingOptions?.options?.filter(
          (option) =>
            option.collectNodeAddress?.collectComunaCode === communeCode
        )
      }
    : {
        ...shippingOptions
      };
};

export default getShopsFromRegion;
